<template>
  <div>
     <div class="navs">
       <div class="navs_title">
         <h1 style="font-size:26px">招考系统会员中心</h1>
       </div>
       <div class="column">
         <div v-for="item in list" style="cursor : pointer;" :class="['column_title', path == item.url ? 'is-actives' : '' ]" @click="resolvePath(item.url)">
          <div v-if="item.url == '/tidings'" style=" position: relative;">
            {{item.title}}<div class="point" v-if="if_point"></div>
          </div>
          <span v-else>
            {{item.title}}
          </span>
        </div>
       </div>
     </div>
  </div>
</template>

<script>
  import http from "../../utils/http";
  import api from "../../api";
  export default {
    name: 'SideNav',
    data () {
      return {
        path:'',
        list:[
          {
            'url':"/user",
            'title':'中心首页',
          },
          {
            'url':"/signupxi",
            'title':'报名信息',
          },{
            'url':"/mySign",
            'title':'我要报名',
          },{
            'url':"/tidings",
            'title':'我的消息',
          },{
            'url':"/orders",
            'title':'缴费记录',
          },{
            'url':"/notice",
            'title':'系统公告',
          },
        ],
        if_point:''
      }
    },
    created:function(){
      this.getListData()
      http.get(api.tidingsList, {
        'is_looked' : 2
      })
        .then(res=>{
           if(res.data.items.length > 0){
                this.if_point = true
           }else{
               this.if_point = false
           }
        })
        .catch(() => {})
    },
    methods: {
      getListData()
      {
        this.path = this.$route.path
      },
      resolvePath(routePath) {
        this.path = routePath
        this.$router.push(routePath);
      },
    }
  }
</script>

<style lang="less">
.point{
  position: absolute;
    width: 7px;
    height: 7px;
    right: 105px;
    top: 20px;
    background: #ff0000;
    border-radius: 7px;
}
.is-actives{
  background: #266d86;
  color: #fff;
  border-bottom: none;
}
.column_title{
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  width: 100%;
  height: 60px;
  line-height: 60px;
}
.column{
    width: 300px;
    height: 100%;
    background-color: #f7f7f7;
    float: left;
}
.navs_title{
  text-align: center;
  line-height: 60px;
  background-color: #2c809f;
  color: #fff;
  font-size: 21px;
  width: 300px;
  height: 60px;
}
.navs{
  width:300px;
  position: fixed;
  height:100%;
  left:0px;
  top:0px;
}
.el-menu-item.is-active {
  color: white;
  background-color: #1787FB !important;
}
.el-menu-item:focus, .el-menu-item:hover {
  outline: 0;
  background-color: #409EFF;
}
.el-menu-item-group__title{
  padding: 0px 0 0px 0px;
}
.el-menu-item-group__title:hover {
  background-color: #409eff;
}
.el-submenu__title{
  color:white;
}
.copyright span{
  color:white;
  font-size: 14px;
  margin-left: 20px;
}
.copyright{
  float: left;
  display: inline-block;
}
.operation{
  text-align: right;
  display: inline-block;
  font-size: 12px
}
.nav span{
  color:white;
  font-size: 14px;
  margin-left: 20px;
}
.aside{
  width:200px;
  background-color: #304156;
}
.elContainer{
  position:relative;
  left:0px;
  top:0px;
  height:100vh;
  border: 0px solid #eee
}
.admin{
  position: relative;
  height: 60px;
  line-height: 60px;
}
.admin .adminName{
  padding-left: 75px;
  margin-left: 10px;
}
.admin .adminImg{
  position: absolute;
  margin-left: 30px;
  margin-top: 10px;
  float:left;
}
.admin .adminImg img{
  border-radius: 30px;
  width: 40px;
  height: 40px;
}
.websiteName{
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 24px;
  color: white;
  font-weight: normal;
}
.el-header {
  background-color: rgb(43, 47, 58);
  color: #333;
  line-height: 60px;
}
.el-submenu__title:hover {
  background-color: #409eff;
}
.el-menu{
  border: solid 1px #304156;
  color:white;
  background-color: #304156;
}
.el-aside {
  color: #333;
}
.el-menu-item{
  color:white;
}
</style>



// WEBPACK FOOTER //
// src/Layout/components/SideNav.vue